module.exports = __webpack_public_path__ + "../resources/images/illustration_task-1273857895bf4b854f84a63da5ce6308.svg";